import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const HeaderGuide = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    props.UpdateWalkthrough(true);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const close = () => {
    props.CloseGuide();
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div className="guide-dialog header-guide">
      <i className="feather-x" onClick={() => close()}></i>
      <p className="dialog-text">{translateText("walkthrough_app_header")}</p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.HasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 8 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 7 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div
          className="steps-navs next done-btn"
          onClick={() => props.CloseGuide()}
        >
          <i className="feather-check"></i>
          <p>{translateText("done")}</p>
        </div>
      </section>
    </div>
  );
};

export default HeaderGuide;
